import { SAAS_API_URL } from "./env";

const SAAS_API = SAAS_API_URL;

async function fetchJson(path) {
    const res = await fetch(`${SAAS_API}${path}`, {
        headers: { Accept: "application/json" },
    });
    const json = await res.json();
    if (!res.ok || !json.success) {
        throw new Error(json.message || "Request failed");
    }
    return json.data;
}

export async function fetchBlogPosts() {
    return fetchJson("/api/public/v1/content/blog-posts");
}

export async function fetchBlogPost(slug) {
    return fetchJson(`/api/public/v1/content/blog-posts/${encodeURIComponent(slug)}`);
}

export async function fetchFaqs() {
    return fetchJson("/api/public/v1/content/faqs");
}

export async function fetchChangelog() {
    return fetchJson("/api/public/v1/content/changelog");
}

export async function fetchRoadmap() {
    return fetchJson("/api/public/v1/content/roadmap");
}

export async function fetchUseCases() {
    return fetchJson("/api/public/v1/content/use-cases");
}

export async function fetchCaseStudies() {
    return fetchJson("/api/public/v1/content/case-studies");
}

export async function fetchNotifications() {
    return fetchJson("/api/public/v1/content/notifications");
}

export function findPostBySlug(posts, slug) {
    return posts.find((p) => p.slug === slug) ?? null;
}

export function relatedPosts(posts, post, limit = 3) {
    return posts
        .filter((p) => p.slug !== post.slug && p.category === post.category)
        .slice(0, limit);
}

export function nextPostAfter(posts, post) {
    const index = posts.findIndex((p) => p.slug === post.slug);
    if (index < 0) return null;
    return posts[index + 1] ?? null;
}
